{
  "ar-EG": {
    "title": "النقاط المثيرة للاهتمام",
    "whattodo": "أشياء لفعلها",
    "wheretoeat": "أين تأكل",
    "wheretosleep": "أو النوم",
    "whattosee": "أشياء يمكن رؤيتها",
    "localproducts": "منتوجات محلية",
    "services": "خدمات"
  },
  "ar-SA": {
    "title": "النقاط المثيرة للاهتمام",
    "whattodo": "أشياء لفعلها",
    "wheretoeat": "أين تأكل",
    "wheretosleep": "أو النوم",
    "whattosee": "أشياء يمكن رؤيتها",
    "localproducts": "منتوجات محلية",
    "services": "خدمات"
  },
  "ca-ES": {
    "title": "Punts d'interés",
    "whattodo": "Coses a fer",
    "wheretoeat": "On menjar",
    "wheretosleep": "On dormir",
    "whattosee": "Coses per veure",
    "localproducts": "Productes locals",
    "services": "Serveis"
  },
  "cs-CZ": {
    "title": "Body zájmu",
    "whattodo": "Věci ke splnění",
    "wheretoeat": "Kde jíst",
    "wheretosleep": "Nebo spát",
    "whattosee": "Věci k vidění",
    "localproducts": "Místní produkty",
    "services": "Služby"
  },
  "da-DK": {
    "title": "Interessepunkter",
    "whattodo": "Ting at gøre",
    "wheretoeat": "Hvor skal man spise",
    "wheretosleep": "Eller sove",
    "whattosee": "Ting at se",
    "localproducts": "Lokale produkter",
    "services": "Tjenester"
  },
  "de-AT": {
    "title": "Sehenswürdigkeiten",
    "whattodo": "Dinge die zu tun sind",
    "wheretoeat": "Wo zu essen",
    "wheretosleep": "Wo zu schlafen",
    "whattosee": "Dinge zu sehen",
    "localproducts": "Lokale Produkte",
    "services": "Dienstleistungen"
  },
  "de-CH": {
    "title": "Sehenswürdigkeiten",
    "whattodo": "Dinge die zu tun sind",
    "wheretoeat": "Wo zu essen",
    "wheretosleep": "Wo zu schlafen",
    "whattosee": "Dinge zu sehen",
    "localproducts": "Lokale Produkte",
    "services": "Dienstleistungen"
  },
  "de-DE": {
    "title": "Sehenswürdigkeiten",
    "whattodo": "Dinge die zu tun sind",
    "wheretoeat": "Wo zu essen",
    "wheretosleep": "Wo zu schlafen",
    "whattosee": "Dinge zu sehen",
    "localproducts": "Lokale Produkte",
    "services": "Dienstleistungen"
  },
  "en-CA": {
    "title": "Points of interest",
    "whattodo": "To do",
    "wheretoeat": "Where to eat",
    "wheretosleep": "Where to sleep",
    "whattosee": "To see",
    "localproducts": "Local products",
    "services": "Services"
  },
  "en-GB": {
    "title": "Points of interest",
    "whattodo": "To do",
    "wheretoeat": "Where to eat",
    "wheretosleep": "Where to sleep",
    "whattosee": "To see",
    "localproducts": "Local products",
    "services": "Services"
  },
  "en-HK": {
    "title": "Points of interest",
    "whattodo": "To do",
    "wheretoeat": "Where to eat",
    "wheretosleep": "Where to sleep",
    "whattosee": "To see",
    "localproducts": "Local products",
    "services": "Services"
  },
  "en-IE": {
    "title": "Points of interest",
    "whattodo": "To do",
    "wheretoeat": "Where to eat",
    "wheretosleep": "Where to sleep",
    "whattosee": "To see",
    "localproducts": "Local products",
    "services": "Services"
  },
  "en-IN": {
    "title": "Points of interest",
    "whattodo": "To do",
    "wheretoeat": "Where to eat",
    "wheretosleep": "Where to sleep",
    "whattosee": "To see",
    "localproducts": "Local products",
    "services": "Services"
  },
  "en-US": {
    "title": "Points of interest",
    "whattodo": "To do",
    "wheretoeat": "Where to eat",
    "wheretosleep": "Where to sleep",
    "whattosee": "To see",
    "localproducts": "Local products",
    "services": "Services"
  },
  "es-ES": {
    "title": "Puntos de interés",
    "whattodo": "Cosas para hacer",
    "wheretoeat": "Donde comer",
    "wheretosleep": "Donde dormir",
    "whattosee": "Cosas por ver",
    "localproducts": "Productos locales",
    "services": "Servicios"
  },
  "es-MX": {
    "title": "Puntos de interés",
    "whattodo": "Cosas para hacer",
    "wheretoeat": "Donde comer",
    "wheretosleep": "Donde dormir",
    "whattosee": "Cosas por ver",
    "localproducts": "Productos locales",
    "services": "Servicios"
  },
  "fr-BE": {
    "title": "Les points d'intérêts",
    "whattodo": "A faire",
    "wheretoeat": "Où manger",
    "wheretosleep": "Où dormir",
    "whattosee": "A voir",
    "localproducts": "Produits locaux",
    "services": "Services"
  },
  "fr-CA": {
    "title": "Les points d'intérêts",
    "whattodo": "A faire",
    "wheretoeat": "Où manger",
    "wheretosleep": "Où dormir",
    "whattosee": "A voir",
    "localproducts": "Produits locaux",
    "services": "Services"
  },
  "fr-CH": {
    "title": "Les points d'intérêts",
    "whattodo": "A faire",
    "wheretoeat": "Où manger",
    "wheretosleep": "Où dormir",
    "whattosee": "A voir",
    "localproducts": "Produits locaux",
    "services": "Services"
  },
  "fr-FR": {
    "title": "Les points d'intérêts",
    "whattodo": "A faire",
    "wheretoeat": "Où manger",
    "wheretosleep": "Où dormir",
    "whattosee": "A voir",
    "localproducts": "Produits locaux",
    "services": "Services"
  },
  "hi-IN": {
    "title": "ब्याज के अंक",
    "whattodo": "करने के लिए काम",
    "wheretoeat": "कहाँ खाना है",
    "wheretosleep": "या सो जाओ",
    "whattosee": "देखने लायक चीजें",
    "localproducts": "स्थानीय उत्पाद",
    "services": "सेवाएं"
  },
  "id-ID": {
    "title": "Tempat menarik",
    "whattodo": "Hal yang harus dilakukan",
    "wheretoeat": "Tempat makan",
    "wheretosleep": "Atau tidur",
    "whattosee": "Hal-hal untuk dilihat",
    "localproducts": "Produk lokal",
    "services": "Jasa"
  },
  "it-IT": {
    "title": "Punti di interesse",
    "whattodo": "Cose da fare",
    "wheretoeat": "Dove mangiare",
    "wheretosleep": "Dove dormire",
    "whattosee": "Cose da vedere",
    "localproducts": "Prodotti locali",
    "services": "Servizi"
  },
  "ja-JP": {
    "title": "興味がある点",
    "whattodo": "やる事",
    "wheretoeat": "どこで食べます",
    "wheretosleep": "それとも寝るか",
    "whattosee": "見るべきもの",
    "localproducts": "地元の特産品",
    "services": "サービス"
  },
  "ko-KR": {
    "title": "가볼만한 곳",
    "whattodo": "해야 할 일",
    "wheretoeat": "먹을 곳",
    "wheretosleep": "아니면 잠",
    "whattosee": "볼만한 것들",
    "localproducts": "지역상품",
    "services": "서비스"
  },
  "nb-NO": {
    "title": "Interessepunkt",
    "whattodo": "Ting å gjøre",
    "wheretoeat": "Hvor å spise",
    "wheretosleep": "Hvor å sove",
    "whattosee": "Ting å se",
    "localproducts": "Lokale produkter",
    "services": "Tjenester"
  },
  "nl-BE": {
    "title": "Interessante punten",
    "whattodo": "Dingen om te doen",
    "wheretoeat": "Waar te eten",
    "wheretosleep": "Waar te slapen",
    "whattosee": "Dingen om te zien",
    "localproducts": "Regionale producten",
    "services": "Diensten"
  },
  "nl-NL": {
    "title": "Interessante punten",
    "whattodo": "Dingen om te doen",
    "wheretoeat": "Waar te eten",
    "wheretosleep": "Waar te slapen",
    "whattosee": "Dingen om te zien",
    "localproducts": "Regionale producten",
    "services": "Diensten"
  },
  "pl-PL": {
    "title": "Ciekawe miejsca",
    "whattodo": "Rzeczy do zrobienia",
    "wheretoeat": "Gdzie zjeść",
    "wheretosleep": "Gdzie spać",
    "whattosee": "Rzeczy do zobaczenia",
    "localproducts": "Lokalne produkty",
    "services": "Usługi"
  },
  "pt-BR": {
    "title": "Pontos de interesse",
    "whattodo": "Coisas para fazer",
    "wheretoeat": "Onde comer",
    "wheretosleep": "Onde dormir",
    "whattosee": "Coisas para ver",
    "localproducts": "Produtos locais",
    "services": "Serviços"
  },
  "pt-PT": {
    "title": "Pontos de interesse",
    "whattodo": "Coisas para fazer",
    "wheretoeat": "Onde comer",
    "wheretosleep": "Onde dormir",
    "whattosee": "Coisas para ver",
    "localproducts": "Produtos locais",
    "services": "Serviços"
  },
  "ru-RU": {
    "title": "Точки интереса",
    "whattodo": "Дела, которые необходимо сделать",
    "wheretoeat": "Где поесть",
    "wheretosleep": "Или спать",
    "whattosee": "Вещи, чтобы увидеть",
    "localproducts": "Местные продукты",
    "services": "Услуги"
  },
  "sv-SE": {
    "title": "Intressepunkter",
    "whattodo": "Saker att göra",
    "wheretoeat": "Var man ska äta",
    "wheretosleep": "Vart man ska sova",
    "whattosee": "Saker att se",
    "localproducts": "Lokala produkter",
    "services": "Tjänster"
  },
  "th-TH": {
    "title": "จุดที่น่าสนใจ",
    "whattodo": "สิ่งที่ต้องทำ",
    "wheretoeat": "กินที่ไหนดี",
    "wheretosleep": "หรือนอนหลับ",
    "whattosee": "สิ่งที่น่าดู",
    "localproducts": "สินค้าพื้นเมือง",
    "services": "บริการ"
  },
  "tr-TR": {
    "title": "İlgi noktaları",
    "whattodo": "Yapılacak şeyler",
    "wheretoeat": "Nerede yenir",
    "wheretosleep": "Ya da uyu",
    "whattosee": "Görülecek şeyler",
    "localproducts": "Yerel ürünler",
    "services": "Hizmetler"
  },
  "zh-CN": {
    "title": "兴趣点",
    "whattodo": "要做的事情",
    "wheretoeat": "去哪里吃饭",
    "wheretosleep": "或者睡觉",
    "whattosee": "要看的东西",
    "localproducts": "土特产",
    "services": "服务"
  },
  "zh-HK": {
    "title": "兴趣点",
    "whattodo": "要做的事情",
    "wheretoeat": "去哪里吃饭",
    "wheretosleep": "或者睡觉",
    "whattosee": "要看的东西",
    "localproducts": "土特产",
    "services": "服务"
  },
  "zh-TW": {
    "title": "兴趣点",
    "whattodo": "要做的事情",
    "wheretoeat": "去哪里吃饭",
    "wheretosleep": "或者睡觉",
    "whattosee": "要看的东西",
    "localproducts": "土特产",
    "services": "服务"
  }
}
